// Constants
export const info_agendas = () => {
  return {
    info_agendas: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        dataform: ['paciente_agendar','paciente_agenda'],
        datatype: {
          predeterminate: ''
        }
      }, 
      id_datos_pacientes:{
        type: 'number',
        label: 'Tipo',
        placeholder: '',
        description: 'Tipo de documento',
        validate: 'required',
        dataform: ['paciente_agendar','paciente_agenda'],
        datatype: { 
          disabled: false,
          type: 'select', 
          predeterminate: '',
          list: 'datos_pacientes',
          label: 'name'
        }
      },
      evaluacion: {
        type: 'text',
        label: 'Tipo de Evaluacion Medica',
        dataform: ['paciente_agendar','paciente_agenda'],
        placeholder: '',
        description: 'Tipo de Evaluacion Medica',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',         
        }
      },
    }
  }
}

export function asign_info_agendas(){
  var asign= Object.keys(info_agendas().info_agendas);
  var objeto = info_agendas().info_agendas
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}

